import type { EventSeriesData } from '@beat-venues/common-types';
import { type VariantProps, tv } from 'tailwind-variants';

import { Button, Heading, TextLink } from '../..';
import type { CommonProps } from '../../types';

export interface EventContentCardProps
    extends CommonProps,
        VariantProps<typeof EventContentCardStyles>,
        Pick<EventSeriesData, 'slug' | 'image'> {
    title: string;
    buttonLabel?: string;
}

export const EventContentCardStyles = tv({
    slots: {
        root: 'relative group overflow-hidden rounded-lg flex flex-col hover:no-underline',
        contentCardText:
            'w-full flex bg-gray-500 h-[90px] items-center justify-between gap-2 p-4',
        titleCard: 'mb-0 line-clamp-2 w-[70%] lg:mb-1.5',
        imageContainer: 'transition group-hover:scale-105',
    },
});

export const EventContentCard = ({
    className,
    image,
    title,
    slug,
    buttonLabel,
    testId = 'event-content-card',
    ...props
}: EventContentCardProps): JSX.Element => {
    const { root, imageContainer, contentCardText, titleCard } =
        EventContentCardStyles();

    return (
        <TextLink
            className={root({ className })}
            href={slug}
            underline={false}
            {...props}
            data-testid={testId}
        >
            <div className={imageContainer()}>
                <img
                    className="aspect-banner object-cover"
                    alt={image?.alt || 'placeholder'}
                    src={image?.url || '/assets/my-beat/fallback/fallback.jpg'}
                    width="823"
                    height="462"
                />
            </div>
            <div className={contentCardText()}>
                <Heading as="h4" className={titleCard()} size="h5">
                    {title}
                </Heading>
                {buttonLabel && (
                    <Button className="mt-2" fullWidth={false} size="sm">
                        {buttonLabel}
                    </Button>
                )}
            </div>
        </TextLink>
    );
};
